<div class="search-mobile">
  <!--Search bar for mobile-->
  <div class="input-group col-md-5 searchContainer">
    <i class="fa fa-search search-bar"></i>
    <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
      (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)'
      [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" (keydown.enter)="onKeyEnterSearch($event,selectedValue)"
      (inputCleared)="searchCleared()" aria-label="Type here to Search an Article" placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a [innerHTML]="item.name"></a>
    </ng-template>
    <ng-template #notFoundTemplate let-notFound>
          No Suggestion...
    </ng-template>
    <span class="input-group-append" (click)="search(selectedValue)">
      <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
        <i class="fa fa-search"></i>
      </button>
    </span>
  </div>
</div>
<div class="container search-desktop" *ngIf="hideKbSearch==false">
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-5 search-header breadcrumb-header" *ngIf="searchText!=false">
      {{searchBanner}}
    </div>
    <div class="input-group col-md-5 searchContainer">
      <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
        (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)'
        [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" (keydown.enter)="onKeyEnterSearch($event,selectedValue)"
        (inputCleared)="searchCleared()" aria-label="Type here to Search an Article" placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
      </ng-autocomplete>

      <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.name"></a>
      </ng-template>
      <ng-template #notFoundTemplate let-notFound>
            No Suggestion...
      </ng-template>
      <span class="input-group-append" (click)="search(selectedValue)">
        <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
          <i class="fa fa-search"></i>
        </button>
      </span>
    </div>
    <div class="col-md-1"></div>
  </div>
</div>